import type { AppRouteRecordRaw, Menu } from '@/router/types';

import { defineStore } from 'pinia';
import { store } from '@/store';
import {getAdminMenuList, getMenuList, getSystemMenuList} from '@/api/sys/menu';
import { getPermCode } from '@/api/sys/user';
import {dbUtils, initTreeData, StorageUtils} from 'xmgoing-utils';
import GoingUtils, {initTreeMenuData} from "@/utils/goingUtils";
import {getSubAppMenuApi} from "@/api/menu";

interface PermissionState {
  // Permission code list
  // 权限代码列表
  permCodeList: string[] | number[];
  // Whether the route has been dynamically added
  // 路由是否动态添加
  isDynamicAddedRoute: boolean;
  // To trigger a menu update
  // 触发菜单更新
  lastBuildMenuTime: number;
  // Backstage menu list
  // 后台菜单列表
  backMenuList: Menu[];
  // 菜单列表
  frontMenuList: Menu[];
}

export const usePermissionStore = defineStore({
  id: 'app-permission',
  state: (): PermissionState => ({
    // 权限代码列表
    permCodeList: [],
    // Whether the route has been dynamically added
    // 路由是否动态添加
    isDynamicAddedRoute: false,
    // To trigger a menu update
    // 触发菜单更新
    lastBuildMenuTime: 0,
    // Backstage menu list
    // 后台菜单列表
    backMenuList: [],
    // menu List
    // 菜单列表
    frontMenuList: [],
  }),
  getters: {
    getPermCodeList(): string[] | number[] {
      return this.permCodeList;
    },
    getBackMenuList(): Menu[] {
      return this.backMenuList;
    },
    getFrontMenuList(): Menu[] {
      return this.frontMenuList;
    },
    getLastBuildMenuTime(): number {
      return this.lastBuildMenuTime;
    },
    getIsDynamicAddedRoute(): boolean {
      return this.isDynamicAddedRoute;
    },
  },
  actions: {
    setPermCodeList(codeList: string[]) {
      this.permCodeList = codeList;
    },

    setBackMenuList(list: Menu[]) {
      this.backMenuList = list;
      list?.length > 0 && this.setLastBuildMenuTime();
    },

    setFrontMenuList(list: Menu[]) {
      this.frontMenuList = list;
    },

    setLastBuildMenuTime() {
      this.lastBuildMenuTime = new Date().getTime();
    },

    setDynamicAddedRoute(added: boolean) {
      this.isDynamicAddedRoute = added;
    },
    resetState(): void {
      this.isDynamicAddedRoute = false;
      this.permCodeList = [];
      this.backMenuList = [];
      this.lastBuildMenuTime = 0;
    },
    async changePermissionCode() {
      const codeList = await getPermCode();
      this.setPermCodeList(codeList);
    },


    // 构建单位管理员的路由
    async buildAdminRoutesAction(): Promise<AppRouteRecordRaw[]> {
      let userRotes: any = [];
      //先从缓存中获取
      if(!GoingUtils.isAppShowFlag()&&dbUtils.getUserMenus()&&dbUtils.getUserMenus().length>0){
        userRotes = dbUtils.getUserMenus()
      }
      // if(userRotes==null||userRotes.length===0){
        //如果是预览应用模式下 菜单通过模版id获取
        if(!GoingUtils.isAppShowFlag()){
          userRotes = (await getAdminMenuList()) as AppRouteRecordRaw[];
          userRotes=GoingUtils.initAdminUserRotes(userRotes);
          dbUtils.addUserMenus(userRotes);
        }
      // }
      //因为返回的数据 顶层包了一层 需要获取子节点
      let userRotesRcords: any = [];
      if (userRotes && userRotes.length > 0) {
        userRotesRcords = userRotes[0]['children'];
        //处理item的path值
        userRotesRcords&&userRotesRcords.forEach &&
        userRotesRcords.forEach((item: any) => {
          if (item.path == null || item.path === '') {
            item.path = item.id;
          }
        });
      }
      if(userRotesRcords==null){
        let routes: AppRouteRecordRaw[] = [];
        return routes;
      }
      // 将路由转换成菜单
      const menuList = [...userRotesRcords];
      // 设置菜单列表
      this.setFrontMenuList(menuList);
      let routes: AppRouteRecordRaw[] = [];
      return routes;
    },
    // 构建路由
    async buildRoutesAction(name?: string): Promise<AppRouteRecordRaw[]> {
      let userRotes: any = [];
      if(dbUtils.loadMenus){
        return ;
      }
      dbUtils.loadMenus=true;
      //先从缓存中获取
      if(!GoingUtils.isAppShowFlag()&&dbUtils.getUserMenus()&&dbUtils.getUserMenus().length>0){
        if(StorageUtils.getSessionItem("loginUserType")!=='operateUser'&&StorageUtils.getSessionItem("loginUserType")!=='system'){
          userRotes = dbUtils.getUserMenus();
        }
      }
      const position=StorageUtils.getSessionItem("loginUserType");
      //如果是运营用户 则查询运营的相关菜单信息
      if(position==='operateUser'){
        const systemMenus=await getSubAppMenuApi({code: 'system'});
        initTreeMenuData(systemMenus,0);
        userRotes=[
          {
            "id": "1316608142640439298",
            "status": 1,
            "tenantId": "000000",
            "belongId": "1316608142640439298",
            "appOldId": -1,
            "isModuleRoot": "yes",
            "parentId": "0",
            "name": "系统资源管理",
            "pinyin": "xitongziyuanguanli",
            "code": "root",
            "path": "",
            "source": "",
            "sort": 1,
            "remark": "",
            "seqType": "",
            "ancestors": "0",
            "openType": "iframe",
            "moduleName": "userPages",
            "type": "menu",
            "hasButton": "",
            "appId": -1,
            "iconBg": "",
            "mobilePageId": -1,
            "desCtl": "",
            "pcSpace": "",
            "isPublish": "",
            "nameEn": "",
            "nameCn": "",
            "isCollection": -1,
            "children": systemMenus,
            "hasChildren": false
          }
        ];
      }
      //如果缓存里面取了 没有记录 则进行查询
      if(userRotes==null||userRotes.length===0){
        //如果是预览应用模式下 菜单通过模版id获取
        if(!GoingUtils.isAppShowFlag()){
          if(position==='system'){
            userRotes = (await getSystemMenuList()) as AppRouteRecordRaw[];
            userRotes = [{children:initTreeData(userRotes,[],{id:'menuId',parentId:'parentId',children:'children'})}];
          }else{
            userRotes = (await getMenuList({name})) as AppRouteRecordRaw[];
            dbUtils.addUserMenus(userRotes);
          }
        }
      }
      dbUtils.loadMenus=false;
      //因为返回的数据 顶层包了一层 需要获取子节点
      let userRotesRcords: any = [];
      if (userRotes && userRotes.length > 0) {
        userRotesRcords = userRotes[0]['children'];
        //处理item的path值
        userRotesRcords&&userRotesRcords.forEach &&
          userRotesRcords.forEach((item: any) => {
            item.source=item.source||item.menuIcon;
            delete item.icon;
            if (item.path == null || item.path === '') {
              item.path = item.id;
            }
          });
      }
      if(userRotesRcords==null){
        let routes: AppRouteRecordRaw[] = [];
        return routes;
      }
      // 将路由转换成菜单
      const menuList = [...userRotesRcords];
      // 设置菜单列表
      this.setFrontMenuList(menuList);
      let routes: AppRouteRecordRaw[] = [];
      return routes;
    },
  },
});

// Need to be used outside the setup
// 需要在设置之外使用
export function usePermissionStoreWithOut() {
  return usePermissionStore(store);
}
